
<modal :state="state" class="formula-modal md" @toggle-modal="cancel" :should-cancel-on-outside-click="false" prevent-esc>
  <div slot="body" ref="formulaModal">
    <h3 class="modal-title">{{targetFormula.originalText ? 'Edit' : 'Add'}} Formula</h3>
    <p>In the space below, you can write functions from scratch, insert from a preselected list, or add model properties to create a new formula.</p>

    <formula-editor
      ref="formulaEditor"
      v-if="state.isVisible"
      id="formula-field"
      v-model="targetFormula.text"
      :codeMirrorAble="formula"
      :dynamicOptions="dynamicOptions"
      :config="{autoClearEmptyLines: false, lineWrapping: true, lineNumbers: true}"
      @openFieldsPopupMenu="openPopupOnClick($event)"
      @chip-cleared="resetMark">
    </formula-editor>

    <div class="cta mt-3">
      <button type="button" class="btn grey block text-nowrap max-width-fit-content" @click="openPopup($event, 'formula')">
        Insert Formula Functions
      </button>
      <button type="button" v-if="hasDynamicOptions" class="btn grey block text-nowrap max-width-fit-content" @click="openPopup($event, 'fields')">
        Insert {{getDynamicFieldsTitle(dynamicOptions[0])}}
      </button>
    </div>

    <context-menu
      ref="formulaContextMenu"
      :state="modalStateFor(vueModalID.formulaFunctions)"
      :index="vueModalID.formulaFunctions"
      fixed
      @close="closePopup($event, 'formula')">
      <dynamic-fields-tree
        v-bind="formulaDynamicFieldsProps"
        @select="addWidget(WidgetType.FormulaFunctionWidget, $event)">
        <template #heading>
          <h4 class="popup-title">Formula Functions</h4>
        </template>
      </dynamic-fields-tree>
    </context-menu>

    <context-menu
      v-if="hasDynamicOptions"
      ref="fieldsContextMenu"
      :state="modalStateFor(vueModalID.formFields)"
      :index="vueModalID.formFields"
      fixed
      @close="closePopup($event, 'fields')">
      <component
        v-for="options in dynamicOptions"
        :key="`dynamic-option-${options.title}-${index}`"
        :is="options.is"
        @select="addWidget(WidgetType.FormFieldWidget, $event)"
        v-bind="options.props">
        <template #heading>
          <h4 class="popup-title">{{getDynamicFieldsTitle(options)}}</h4>
        </template>
      </component>
    </context-menu>

    <div class="rule-preview">
      <h5>Preview</h5>

      <div class="condition-block">
        <p>{{formulaEvaluation}}</p>
        <p v-if="currentParseError">{{currentParseError}}</p>
      </div>
    </div>

    <p class="text-left">
      <a href="/formulas" class="link" target="_blank">Test this formula</a><help-tooltip text="This formula is calculated on the server. Please test the formula prior to publishing."></help-tooltip>
    </p>

    <flash-attribute-messages v-if="shouldValidate && !targetFormula.isComplete()" messages="You must complete the formula before you can continue."></flash-attribute-messages>

    <div class="cta">
      <button v-if="targetFormula.originalText" class="btn block red outline" @click.prevent="remove($event)">Remove</button>
      <button class="btn block red outline" @click.prevent="cancel">Cancel</button>
      <button class="btn block green" @click.prevent="save">Save</button>
    </div>
  </div>
</modal>
